import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Button } from '@skbkontur/react-ui';
import { ErrorListUrl } from '@skbkontur/staff-common';
import { listDict } from '../../../constants';
import { EmployeeListContext } from '../EmployeeList.context';
import classes from '../EmployeeList.module.css';
export const ErrorMessage = () => {
    const { listType, handleListReload } = useContext(EmployeeListContext);
    return (_jsxs("div", { className: classes.listMessage, children: [_jsx("img", { src: ErrorListUrl, alt: "ErrorList" }), _jsxs("div", { className: classes.listMessageText, children: [listDict[listType].errorTitle, _jsx("br", {}), _jsx(Button, { use: "link", onClick: handleListReload, children: "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437" })] })] }));
};
